import React from 'react';
import { FileText, Download, ShieldCheck } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Customer-facing card: preview + download watermarked mouza (revenue) PDF.
// Backend applies the "ACRE MITRA · VERIFIED" diagonal watermark on-the-fly.
export const MouzaMapCard = ({ property }) => {
  if (!property?.mouza_map_url) return null;

  const downloadUrl = `${BACKEND_URL}/api/properties/${property.id}/mouza-map.pdf`;

  return (
    <div
      className="rounded-2xl border-2 border-emerald-200 bg-gradient-to-br from-emerald-50 to-white p-5"
      data-testid="mouza-map-card"
    >
      <div className="flex items-start gap-3">
        <div className="w-11 h-11 rounded-xl bg-emerald-700 text-white flex items-center justify-center shrink-0">
          <FileText size={20} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <h3 className="font-bold text-slate-900 text-base">Mouza Map (Revenue Record)</h3>
            <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-emerald-700 bg-white border border-emerald-200 rounded-full px-2 py-0.5">
              <ShieldCheck size={10} /> Verified
            </span>
          </div>
          <p className="text-xs text-slate-600 mt-1">
            Official plot map with an <strong>Acre Mitra · Verified</strong> diagonal watermark
            on every page — safe to share with lawyers, banks and surveyors.
          </p>
        </div>
      </div>

      {/* Inline preview via <iframe> — uses each browser's native PDF viewer */}
      <div className="mt-4 rounded-xl overflow-hidden border border-slate-200 bg-slate-100 aspect-[4/3]">
        <iframe
          title={`Mouza map — ${property.title}`}
          src={`${downloadUrl}#toolbar=0&navpanes=0&view=FitH`}
          className="w-full h-full border-0"
          loading="lazy"
          data-testid="mouza-map-preview"
        />
      </div>

      <a
        href={`${downloadUrl}?download=1`}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-3 w-full inline-flex items-center justify-center gap-2 bg-emerald-700 hover:bg-emerald-800 text-white font-bold py-3 rounded-xl transition-colors"
        data-testid="mouza-map-download"
      >
        <Download size={16} /> Download watermarked PDF
      </a>
      <p className="text-[10px] text-slate-500 text-center mt-1.5">
        Reference code · {property.property_code || property.id.slice(0, 8).toUpperCase()}
      </p>
    </div>
  );
};

export default MouzaMapCard;
